import { getFeature } from "./features";
import criteoConfig from "../../common/CriteoAdvertsForRecs/config";

// Resolves the bucket of the Google-ads-vs-Criteo experiment:
// v1 = Google ad, v2 = Criteo banner (BDSS), v3 = no ad. Defaults to v1 when
// the experiment is not enabled, matching the ad banner's fallback.
export const getCriteoAdsBucket = () => {
  const feature = getFeature(criteoConfig.experimentKey);

  return feature?.isEnabled?.() ? feature?.getVariables?.()?.bucket : "v1";
};

export const isCriteoBannerBucket = () => getCriteoAdsBucket() === "v2";
